module.exports = __webpack_public_path__ + "img/add-curve.d20bdefe.svg";